import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import style from "../../styles/form.module.css";

function ABMCosto() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "costo";

   const location = useLocation();
   const { state } = location;
   const estados = Estado();
   const navigate = useNavigate();
   const servicios = state ? state.servicios : 0;
   const [input, setInput] = useState({
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      serv_id: state ? state.serv_id : "",
      precio: state ? state.precio : 0,
      cod_status: state ? state.cod_status : "1",
   });

   var btnGrabar = true;
   var metodo = 'POST'
   var usrCosto = ""
   function handleServicio(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   function handleStatus(e) {
      e.preventDefault();
      setInput({
         ...input,
         cod_status: e.target.value,
      });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("input: ", input);
      if (input.cod_status === 0) {
         alert("Debe Ingresar un Status");
         return;
      }
      if (input.id ===0) {
         usrCosto=url 
         metodo='POST'
      } else {
         usrCosto=url + `/${input.id}`
         metodo='PUT'
      }
      mutate(input);
   };

   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(usrCosto, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         // console.log('url`: ', url + `/${newPost.id}`)
         // console.log('newPost: ', newPost);
         //queryClie nt.invalidateQueries({queryKey:["posts"]})  REFRESCA TODA LA DATA
         // queryClient.setQueryData(["posts"], (oldPosts) => [
         //    ...oldPosts,
         //    newPost,
         // ]);
         window.location.href = "/costo";
      },
      onError: (error) => {
         alert(error);
      },
   });

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Porcentajes de Costos en los Servicio</h1>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Servicio id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                        <span>Servicio:</span>&nbsp;
                        <select
                           className={style.selData}
                           name="serv_id"
                           id="serv_id"
                           onChange={(e) => handleServicio(e)}
                           value={input.serv_id}
                        >
                           <option value="0">Seleccionar</option>
                           {servicios &&
                              servicios.map((data) => {
                                 return (
                                    <option
                                       selected
                                       value={data.id}
                                       key={data.id}
                                    >{`${data.descripcion}`}</option>
                                 );
                              })}
                        </select>                     
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Precio:</span>
                     <label htmlFor="precio"></label>
                     <input
                        type="number"
                        id="precio"
                        name="precio"
                        value={input.precio}
                        onChange={handleChange}
                        className={style.input_field_number}
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleStatus(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id_primay}
                                    key={dat.id_primay}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/costo");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMCosto;
